import { render, staticRenderFns } from "./eliminar-inactivar.vue?vue&type=template&id=2eaf1820&scoped=true"
import script from "./eliminar-inactivar.vue?vue&type=script&lang=js"
export * from "./eliminar-inactivar.vue?vue&type=script&lang=js"
import style0 from "./eliminar-inactivar.vue?vue&type=style&index=0&id=2eaf1820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaf1820",
  null
  
)

export default component.exports